import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { TMemberListQuery } from '@/services/members';

import { MEMBER_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { membersService } from '@/services/members';
import { useStaffSession } from '@/hooks/auth';

const useMembers = (query: TMemberListQuery, isEnabled: boolean = true) => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: MEMBER_KEYS.list(query),
    queryFn: async () => errorUtils.unwrap(await membersService.listMembers(query)),
    enabled: isEnabled && session?.stage === 'ready',
    placeholderData: keepPreviousData,
  });
};

export {
  useMembers,
};
